import { render, staticRenderFns } from "./ViewDishesQrCode.vue?vue&type=template&id=2834779c&scoped=true&"
import script from "./ViewDishesQrCode.vue?vue&type=script&lang=ts&"
export * from "./ViewDishesQrCode.vue?vue&type=script&lang=ts&"
import style0 from "./ViewDishesQrCode.vue?vue&type=style&index=0&id=2834779c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2834779c",
  null
  
)

export default component.exports